module.exports = __webpack_public_path__ + "media/images/star-outline-abdf0faf4b7a5f228d7dd6ca8df5aa81.svg";